import React from 'react'

import { applyStyle, getSmartSize } from '../helpers/styles'

const genPositionWithPlacement = ({ top, left, right, bottom, placement }) => {
  if (placement?.startsWith('bottom')) {
    top = 0
    bottom = undefined
  } else if (placement?.startsWith('top')) {
    top = undefined
    bottom = 0
  }

  if (placement?.endsWith('Right')) {
    right = 0
    left = undefined
  } else if (placement?.endsWith('Left')) {
    right = undefined
    left = 0
  }

  return { top, left, right, bottom }
}

export const usePositionStyle = props => {
  let { position, zIndex } = props

  return React.useMemo(() => {
    const { top, left, right, bottom } = genPositionWithPlacement(props)

    return `
      ${applyStyle('position', position)}
      ${applyStyle('top', top, getSmartSize(top))}
      ${applyStyle('bottom', bottom, getSmartSize(bottom))}
      ${applyStyle('left', left, getSmartSize(left))}
      ${applyStyle('right', right, getSmartSize(right))}
      ${applyStyle('z-index', zIndex)}
    `
  }, [position, props.placement, props.top, props.left, props.bottom, props.right, zIndex])
}
